import { render, staticRenderFns } from "./RgZoomPic.vue?vue&type=template&id=bf99ccc6&scoped=true&"
import script from "./RgZoomPic.vue?vue&type=script&lang=js&"
export * from "./RgZoomPic.vue?vue&type=script&lang=js&"
import style0 from "./RgZoomPic.vue?vue&type=style&index=0&id=bf99ccc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf99ccc6",
  null
  
)

export default component.exports